import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eebe3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "concent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "border_div" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "border_div" }, null, -1))
const _hoisted_5 = { class: "panel_div" }
const _hoisted_6 = { class: "order_no_box" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" COPY ")
const _hoisted_8 = { class: "order_other_info" }
const _hoisted_9 = { class: "order_other_info" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Payment Method: Online Payment ")
const _hoisted_11 = {
  key: 0,
  class: "warning"
}
const _hoisted_12 = {
  key: 1,
  class: "success"
}
const _hoisted_13 = { class: "panel_div" }
const _hoisted_14 = { class: "panel_div bottom_btn_box" }
const _hoisted_15 = { class: "amont_font" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Cancel Order")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Pay Now")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Cancel & Refund")
const _hoisted_20 = { class: "mpase_content_div" }
const _hoisted_21 = {
  key: 0,
  class: "m_pesa_phone_msg"
}
const _hoisted_22 = { class: "proceed_div" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Proceed")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_Address = _resolveComponent("Address")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_OrderGoods = _resolveComponent("OrderGoods")!
  const _component_order_price = _resolveComponent("order-price")!
  const _component_pay_now_popup = _resolveComponent("pay-now-popup")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "My Orders",
      backgroundColor: "#424040",
      fontColor: "#fff",
      skipPath: '/order?name='+$setup.route.query.name
    }, null, 8, ["skipPath"]),
    _hoisted_2,
    _createVNode(_component_van_row, {
      class: "order_statu",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, null, {
          default: _withCtx(() => [
            _createTextVNode("Order Status: " + _toDisplayString($setup.orderInfo.state), 1)
          ]),
          _: 1
        }),
        ($setup.route.query.name == 'state_paid' || $setup.route.query.name == 'state_trasit')
          ? (_openBlock(), _createBlock(_component_van_col, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: "check_info",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.checkLogistics && $setup.checkLogistics(...args)))
                }, "Check logistics info")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_3,
    _createElementVNode("div", null, [
      _createVNode(_component_Address, {
        address_message: false,
        item: $setup.orderInfo.receiver
      }, null, 8, ["item"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(" Order No: " + _toDisplayString($setup.orderInfo.sn) + " ", 1),
        _withDirectives((_openBlock(), _createBlock(_component_van_button, {
          size: "mini",
          round: "",
          plain: "",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })), [
          [_directive_clipboard, $setup.orderInfo.sn, "copy"],
          [_directive_clipboard, $setup.onCopy, "success"],
          [_directive_clipboard, $setup.onError, "error"]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, " Order Time: " + _toDisplayString($setup.orderInfo.created_at), 1),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        ($setup.orderInfo.if_pay == true || $setup.orderInfo.state === 'Canceled' )
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(Unpaid)"))
          : _createCommentVNode("", true),
        ($setup.orderInfo.if_pay == false && $setup.orderInfo.state !== 'Canceled')
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(Already Paid)"))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderInfo.goods, (item) => {
      return (_openBlock(), _createBlock(_component_OrderGoods, {
        good_item: item,
        key: item.goods_id,
        onClick: ($event: any) => ($setup.goGoodsFn(item.goods_id))
      }, null, 8, ["good_item", "onClick"]))
    }), 128)),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_order_price, { order_price_obj: $setup.order_price_obj }, null, 8, ["order_price_obj"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("span", _hoisted_15, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($setup.payInfo.amount_pay).thousands()), 1),
      _createElementVNode("div", null, [
        ($setup.orderInfo.if_delete)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 0,
              size: "small",
              square: "",
              type: "primary",
              plain: "",
              class: "subBtn cancel_font",
              onClick: $setup.click_delete_fn,
              color: "#dcdfe6"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        ($setup.orderInfo.if_cancel)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 1,
              size: "small",
              square: "",
              type: "primary",
              plain: "",
              class: "subBtn cancel_font",
              onClick: $setup.click_cancel_fn,
              color: "#dcdfe6"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        ($setup.orderInfo.if_pay)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 2,
              size: "small",
              square: "",
              type: "primary",
              class: "subBtn",
              color: "#F87622",
              onClick: $setup.openOpopup
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        ($setup.orderInfo?.order_state === 20)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 3,
              size: "small",
              square: "",
              type: "primary",
              class: "subBtn cancel_font",
              color: "#dcdfe6",
              onClick: $setup.click_aftersale_fn
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_pay_now_popup, {
      isShowPayPop: $setup.isShowPayPop,
      payInfo: $setup.payInfo,
      onClosePopupFn: $setup.closePopupFn,
      onM_pesa_showFn: $setup.m_pesa_showFn
    }, null, 8, ["isShowPayPop", "payInfo", "onClosePopupFn", "onM_pesa_showFn"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.m_pesa_show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.m_pesa_show) = $event)),
      title: "Enter the M-PESA Account"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            ref: "mpesa_mobile",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.m_pesa_phone) = $event)),
            type: "text",
            placeholder: "Please enter your phone number"
          }, null, 512), [
            [_vModelText, $setup.m_pesa_phone]
          ]),
          ($setup.m_pesa_error_msg_show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Please enter a valid Mpesa number"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_van_button, {
              loading: $setup.mpesa_loading,
              type: "primary",
              onClick: $setup.m_pesa_submit_fn
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}